module.exports = __webpack_public_path__ + "static/khairul-c4edbab6d08a8d77690a4931d9b72ada.mp4";